import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Users, PlayCircle, ExternalLink, ArrowRight, Sparkles, FlaskConical } from "lucide-react";
import { COLORS } from "@/lib/api";

const SP = "https://girlupmx.sharepoint.com/:f:/s/GirlUpALCA.C/";

const EDICIONES = [
  {
    num: "1ª",
    year: "2022",
    title: "Co-liderazgos y Organización de Clubs",
    asistentes: 50,
    color: COLORS.yellow,
    desc: "La primera generación del PAC. Sesiones virtuales los sábados a las 11:00 am (CT), con duración promedio de 90 minutos.",
    singleLink: "https://bit.ly/CarpetaSesionesGU",
    sesiones: [
      { t: "Bienvenida", fecha: "Sáb 5 feb 2022", d: "Presentación del equipo de Juventudes Latentes y del Programa." },
      { t: "Co-liderazgos", fecha: "Sáb 19 feb 2022", d: "Taller sobre liderazgo consciente, efectivo y sano en la gestión de clubs, y el apoyo colectivo." },
      { t: "Manejo de redes", fecha: "Sáb 5 mar 2022", d: "Herramientas y recomendaciones sobre el manejo de las redes sociales." },
      { t: "Gestión de finanzas", fecha: "Sáb 26 mar 2022", d: "Consejos sobre la tesorería del club, patrocinios y donativos." },
      { t: "Organización de eventos", fecha: "Sáb 2 abr 2022", d: "Herramientas y sugerencias para planear y ejecutar eventos." },
      { t: "Autocuidado", fecha: "Sáb 14 may 2022", d: "Manejo de emociones, autocuidado y activismo sano y seguro." },
      { t: "Transición de liderazgos", fecha: "Sáb 21 may 2022", d: "Etapas para una transición de liderazgos efectiva." },
    ],
  },
  {
    num: "2ª",
    year: "2023",
    title: "Acción Social y Vinculación",
    asistentes: 65,
    color: COLORS.lime,
    desc: "Segunda generación: abrir, comunicar y sostener un club, con acción social y vinculación comunitaria.",
    sesiones: [
      { t: "Bienvenidas a la Comunidad Juventudes Latentes", url: "https://drive.google.com/drive/folders/11bNFplenXaV-ClXYRn48dd2yIxjyr4qi?usp=share_link" },
      { t: "Comunicaciones y co-liderazgos", url: "https://drive.google.com/drive/folders/1eZY4XW_dTcbji19DEoBW-gTnlHowKgkI?usp=share_link" },
      { t: "Gestión emocional + seguridad", url: "https://drive.google.com/drive/folders/1ygKxPGHzt-6E7fOxYPpSbOQ64njsej1v?usp=share_link" },
      { t: "Protección intelectual", url: "https://drive.google.com/drive/folders/1wyjVkhEaBYa7QaOnUhIpKu4XMZlDjNkm?usp=sharing" },
      { t: "Finanzas", url: "https://drive.google.com/drive/folders/14i54eLtB86Z15nBoPi8WjlLpwniJ4Q3Y?usp=sharing" },
      { t: "Estrategias de incidencia para clubs", url: "https://drive.google.com/drive/folders/14i54eLtB86Z15nBoPi8WjlLpwniJ4Q3Y?usp=share_link" },
      { t: "Amplifica tu impacto conscientemente", url: "https://drive.google.com/drive/folders/1jQEduvsAMxnS5dhcc6om8mSUYUavWUWc?usp=share_link" },
      { t: "Transición de liderazgos", url: "https://drive.google.com/drive/folders/1iKpAXwwkvRwEP6ONjMzXXQRJqPnqELoD?usp=share_link" },
    ],
  },
  {
    num: "3ª",
    year: "2024",
    title: "Gestión de Clubs",
    asistentes: 95,
    color: COLORS.orange,
    desc: "Herramientas para gestionar un club: eventos, finanzas e incidencia pública.",
    sesiones: [
      { t: "Bienvenida + seguridad en marchas", url: SP + "EtC8RL2Cz-ZEsv78f_4ti54B39zDfQBqbPjrxN4oY3hJQA?e=AhKuJf" },
      { t: "Gestión de eventos colectivos", url: SP + "Em76bdbTckRDsGvqrtzF7JcBIoaX34dKAAip32ocv_U2Kw?e=eLBI4f" },
      { t: "Gestión financiera y sostenibilidad", url: SP + "Es5_OgCHaR1HoaMf4MbcJmQBIZwGbcsvi6ZjjNHEOomHbQ?e=AeFsZG" },
      { t: "Cabildeo e incidencia pública desde mi club", url: SP + "Ep4RZarLt2ZLssrNqo1MwRQBz78X8X0BdNahrLxpE0HrBQ?e=S54uGa" },
    ],
  },
  {
    num: "4ª",
    year: "2025",
    title: "Escuela de Teoría Feminista",
    asistentes: 231,
    color: COLORS.magenta,
    desc: "Las participantes profundizan en los fundamentos del feminismo: su historia, corrientes y referentes, fortaleciendo el pensamiento crítico y el liderazgo con perspectiva de género.",
    sesiones: [
      { t: "Olas del feminismo e hitos en México", url: SP + "Ejq_YCc3tfVBlEUhiUuBtf0BUnYp8v9aa_7c9drFd3KDsA?e=esPbWB" },
      { t: "Feminismo interseccional", url: SP + "ErB9N9BSq61OrEEutudPIhYB_5xSpRGhoI_J-bD70nc37w?e=E0o5f9" },
      { t: "Teoría del cuidado y economía feminista", url: SP + "ElRCQ3PuhPhNoomspNKP578Bje2N3gZfvxDDIwtAl_rOcw?e=kKiegZ" },
      { t: "Teoría crítica de la raza", url: SP + "EhLYpOHt_w1FrXJv3p4njE0Bhbz77QMIHaawoBdIoRSLUQ?e=JRrVFG" },
      { t: "Feminismo e igualdad vs. feminismo de diferencia", url: SP + "EiXulgqP6dVAlJrYlGFLdhUBc9K4SZPjLbwCb-tVbqdPNw?e=rJ2iKe" },
      { t: "Religión, feminismo y fundamentalismos", url: SP + "ErMVRKy_D1dGrA3A2ttvNA8BhYdXSt5zORyzuJFc-4Dz9g?e=RDXSOf" },
      { t: "Ecofeminismo", url: SP + "EsEureRQNkZClwh5pscZBxEBCJkucERX2tOJs_-_yE2AbQ?e=maB93d" },
      { t: "Cuerpos en resistencia: salud femenina y derechos reproductivos", url: SP + "EjrlwNgKbmxOmkCte6QxSckBwQfUeS0k6tYAJ9x9QjQNXQ?e=WMpJoE" },
      { t: "Expresiones artísticas de resistencia en América Latina", url: SP + "Eoc6t4ouz9VDs_3snEfE914Brez1wALNa8kCHIa6RUrzgA?e=aIsQL0" },
      { t: "Matrimonios infantiles y uniones forzadas", url: SP + "EqxnordNrKpPkjM_6g4XDGUBeEJPFM6qRSvMFEp6ct6npw?e=adDspW" },
    ],
  },
];

const fade = { hidden: { opacity: 0, y: 18 }, show: { opacity: 1, y: 0, transition: { duration: 0.45 } } };

const EdicionCard = ({ e }) => (
  <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={fade} className="border border-[#E5E5E5] rounded-sm overflow-hidden" data-testid={`edicion-${e.year}`}>
    <div className="p-6 flex items-start justify-between gap-4" style={{ background: e.color }}>
      <div>
        <span className="text-xs font-bold text-brand-ink/60 uppercase tracking-wide">{e.num} Edición · {e.year}</span>
        <h3 className="font-heading text-2xl font-bold tracking-tight text-brand-ink mt-1">{e.title}</h3>
      </div>
      <div className="flex-shrink-0 text-right">
        <p className="font-heading text-3xl font-bold text-brand-ink leading-none">{e.asistentes}</p>
        <p className="text-xs font-semibold text-brand-ink/70 flex items-center gap-1 justify-end mt-1">
          <Users size={12} /> asistentes
        </p>
      </div>
    </div>
    <div className="p-6">
      <p className="text-brand-ink/75 leading-relaxed">{e.desc}</p>

      {e.singleLink ? (
        <>
          <a
            href={e.singleLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`edicion-link-${e.year}`}
            className="mt-5 inline-flex items-center gap-2 bg-brand-ink text-white font-semibold px-5 py-3 rounded-sm hover:bg-brand-magenta transition-colors"
          >
            Ver las {e.sesiones.length} sesiones grabadas <ExternalLink size={16} />
          </a>
          <ul className="mt-6 space-y-4">
            {e.sesiones.map((s, i) => (
              <li key={i} className="flex gap-3">
                <PlayCircle size={17} className="text-brand-magenta flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium text-brand-ink">Sesión {i + 1}: {s.t}</p>
                  {s.fecha && <p className="text-xs font-semibold text-brand-ink/45 mt-0.5">{s.fecha}</p>}
                  {s.d && <p className="text-sm text-brand-ink/70 mt-1">{s.d}</p>}
                </div>
              </li>
            ))}
          </ul>
        </>
      ) : e.sesiones.length > 0 ? (
        <ul className="mt-5 space-y-1">
          {e.sesiones.map((s, i) => (
            <li key={i}>
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`sesion-link-${e.year}-${i}`}
                className="group flex items-center justify-between gap-3 py-2.5 px-3 -mx-3 rounded-sm hover:bg-[#F6F6F6] transition-colors"
              >
                <span className="flex items-center gap-2.5 text-brand-ink">
                  <PlayCircle size={17} className="text-brand-magenta flex-shrink-0" />
                  <span className="font-medium">Sesión {i + 1}: {s.t}</span>
                </span>
                <span className="flex items-center gap-1 text-sm font-semibold text-brand-magenta flex-shrink-0">
                  Ver recursos <ExternalLink size={13} />
                </span>
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-4 text-sm text-brand-ink/50 italic">Recursos de esta edición próximamente.</p>
      )}
    </div>
  </motion.div>
);

const ProgramaAcompanamiento = () => {
  return (
    <div data-testid="subpage-programa-de-acompanamiento">
      {/* Hero */}
      <section className="relative overflow-hidden border-b border-[#E5E5E5]" style={{ background: `linear-gradient(120deg, ${COLORS.orange} 0%, ${COLORS.magenta} 100%)` }}>
        <div className="relative max-w-4xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Link to="/programas" data-testid="subpage-back" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white mb-6">
            <ArrowLeft size={16} /> Programas
          </Link>
          <span className="inline-block w-16 h-1.5 rounded-sm mb-6 bg-white" />
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[0.98]">
            Programa de Acompañamiento a Clubs
          </h1>
          <p className="mt-5 text-lg md:text-xl text-white/90 font-medium max-w-2xl">
            Cada año acompañamos a las nuevas mesas de liderazgo con sesiones formativas, recursos
            y comunidad. Explora las ediciones y accede a sus contenidos grabados.
          </p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        {/* Intro */}
        <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={fade} className="flex items-start gap-3 rounded-sm p-5 mb-12" style={{ background: "#FFF3E0", border: `1px solid ${COLORS.orange}` }}>
          <Sparkles size={22} className="text-brand-orange flex-shrink-0 mt-0.5" />
          <p className="text-brand-ink/85">
            <span className="font-semibold text-brand-ink">Es más que una guía:</span> cada edición y sesión
            está diseñada para fortalecer tu liderazgo, impulsar la sororidad y construir comunidades más
            justas e igualitarias. Aquí encontrarás las sesiones grabadas y recursos para compartir con tu club.
          </p>
        </motion.div>

        {/* Ediciones */}
        <div className="space-y-8">
          {EDICIONES.map((e) => (
            <EdicionCard key={e.year} e={e} />
          ))}

          {/* Última edición: Laboratorio */}
          <motion.div initial="hidden" whileInView="show" viewport={{ once: true }} variants={fade} className="border border-[#E5E5E5] rounded-sm overflow-hidden" data-testid="edicion-laboratorio">
            <div className="p-6 flex items-start justify-between gap-4 bg-brand-ink">
              <div>
                <span className="text-xs font-bold text-white/60 uppercase tracking-wide">Última edición · 2026</span>
                <h3 className="font-heading text-2xl font-bold tracking-tight text-white mt-1">Laboratorio de Incidencia Pública</h3>
              </div>
              <FlaskConical size={28} className="text-brand-magenta flex-shrink-0" />
            </div>
            <div className="p-6">
              <p className="text-brand-ink/75 leading-relaxed">
                Nuestra edición más reciente lleva la voz de las juventudes a los espacios de decisión.
                Conoce todo sobre el Laboratorio, sus sesiones y materiales en su página dedicada.
              </p>
              <Link
                to="/programas/laboratorio-de-incidencia"
                data-testid="lab-link"
                className="mt-5 inline-flex items-center gap-2 bg-brand-magenta text-white font-semibold px-5 py-3 rounded-sm hover:bg-brand-orange transition-colors"
              >
                Ir a la página del Laboratorio <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>

        {/* Testimonio */}
        <motion.figure initial="hidden" whileInView="show" viewport={{ once: true }} variants={fade} className="mt-16 rounded-sm p-8 md:p-10" style={{ background: "#FDE7FA" }} data-testid="pac-testimonio">
          <blockquote className="font-heading text-xl md:text-2xl font-medium text-brand-ink leading-relaxed">
            “En lo personal considero que cuando vas iniciando en los Clubs y que necesitas una introducción
            al feminismo, el programa de acompañamiento es ideal: te ayuda a cuestionar, a pensar y aprender
            sobre temas nuevos. A mí me hubiera gustado muchísimo tener información así a la mano cuando estaba
            en prepa y me siento muy feliz de que ahora las nuevas generaciones de Juventudes Latentes puedan
            tener el beneficio del PAC. Agradezco todas las opiniones compartidas en estos meses y el
            aprendizaje que me llevo junto con mis compañeras.”
          </blockquote>
          <figcaption className="mt-5 font-semibold text-brand-magenta">— María González, Club Políticas</figcaption>
        </motion.figure>

        {/* CTA */}
        <Link to="/red-de-clubs/como-abrir-un-club" data-testid="abrir-club-cta" className="mt-14 group flex items-center justify-between gap-4 bg-brand-orange rounded-sm p-8 hover:bg-brand-magenta transition-colors duration-200">
          <div>
            <h3 className="font-heading text-2xl font-semibold tracking-tight text-white">¿Quieres formar parte del próximo PAC?</h3>
            <p className="mt-1 text-white/80">Abre tu club y súmate a la próxima edición del programa.</p>
          </div>
          <ArrowRight size={26} className="text-white flex-shrink-0 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default ProgramaAcompanamiento;
